module.exports = __webpack_public_path__ + "static/media/3.a230656e.jpg";